const Card = ({
  children,
  footer,
  text,
  className,
  parentClassName,
}: CardInterface) => {
  return (
    <>
      <div
        className={`p-2 border border-disable rounded-md flex flex-col
         justify-center items-end bg-white  shadow-inner  ${parentClassName}`}
      >
        <div className={className}>
          <div className='w-full break-all text-sm flex flex-row-reverse justify-between'>
            {text} {children}
          </div>
        </div>
        {footer}
      </div>
    </>
  )
}

export default Card
